import { queryOptions, useQuery } from "@tanstack/react-query";

import { CertificateMetadata, cloudStorageKeys } from "../types";
import { getCloudStorage } from "../utils/get-cloud-storage";

export const getCertificatesQueryOptions = (params: Params) => {
  return queryOptions({
    queryKey: ["certificates", params],
    queryFn: async () => {
      const cloudStorage = getCloudStorage();

      const stringifiedCerts = await cloudStorage.getItem(
        cloudStorageKeys.certificates
      );

      if (!stringifiedCerts) return [];

      const certs: CertificateMetadata[] = JSON.parse(stringifiedCerts);

      console.log("certs query: ", certs);

      return certs;
    },
    staleTime: 1000 * 60 * 5,
  });
};

type Params = {
  holderCommitment?: string;
};

export const useCertificatesQuery = (params: Params) => {
  return useQuery(getCertificatesQueryOptions(params));
};
